import { useFormContext } from "react-hook-form";
import { SwitchField } from "../fields/SwitchField";

type Props = {
  label?: string;
  name: string;
  value?: any;
} & React.ClassAttributes<HTMLInputElement> &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;

export const SwitchInput = ({
  label,
  name,
  value,
  onChange,
  ...rest
}: Props) => {
  const { register } = useFormContext();
  const { ref, onChange: hookOnChange, ...hookFormProps } = register(
    name as string
  );

  const customOnChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    hookOnChange(e);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <SwitchField
      label={label}
      value={value}
      innerRef={ref}
      onChange={customOnChange}
      {...rest}
      {...hookFormProps}
    />
  );
};
